import { render, staticRenderFns } from "./SampleDashboard.vue?vue&type=template&id=3c16237a&scoped=true"
import script from "./SampleDashboard.vue?vue&type=script&lang=js"
export * from "./SampleDashboard.vue?vue&type=script&lang=js"
import style0 from "./SampleDashboard.vue?vue&type=style&index=0&id=3c16237a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c16237a",
  null
  
)

export default component.exports